import { PRODUCTS_ACTIONS_TYPES } from "./products.types";

export const INITIAL_STATE = {
	products: [],
	kitPending: [],
	sellersKits: []
};

export const productsReducer = (state = INITIAL_STATE, action = {}) => {
	// process.env.NODE_ENV !== "production" && console.log("dispatch");
	// process.env.NODE_ENV !== "production" && console.log(action);
	const { type, payload } = action;
	switch (type) {
		// case USER_ACTIONS_TYPES.SET_CURRENT_USER:
		// 	const isAdminUser = setIsAdminUserReducer(payload);
		// 	return {
		// 		...state,
		// 		currentUser: payload,
		// 		isAdmin: isAdminUser
		// 	};
		case PRODUCTS_ACTIONS_TYPES.SET_PRODUCTS:
			return {
				...state,
				products: payload
			};
		case PRODUCTS_ACTIONS_TYPES.SET_KIT:
			return {
				...state,
				kitPending: payload
			};
		case PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT:
			return {
				...state,
				sellersKits: payload
			};
		default:
			return state;
	}
};
